import { ModalActionTypes } from 'src/store/constants';

const initialState: ModalState = {
  open: false,
  openRegister: false,
  openLogin: false,
  openCheckEmail: false,
  openAccountVerified: false,
  openPurchaseSummary: false,
  openPurchaseSuccess: false,
  openPurchaseError: false
};

const modalReducer = (state = initialState, { type, payload }: ModalAction) => {
  switch (type) {
    case ModalActionTypes.HANDLE_MODAL:
      return { ...state, open: payload };

    case ModalActionTypes.HANDLE_MODAL_REGISTER:
      return {
        ...state,
        openRegister: payload,
        openLogin: false,
        openCheckEmail: false,
        openAccountVerified: false,
        openPurchaseSummary: false
      };

    case ModalActionTypes.HANDLE_MODAL_LOGIN:
      return {
        ...state,
        openLogin: payload,
        openRegister: false,
        openCheckEmail: false,
        openAccountVerified: false,
        openPurchaseSummary: false
      };

    case ModalActionTypes.HANDLE_MODAL_CHECK_EMAIL:
      return {
        ...state,
        openCheckEmail: payload,
        openRegister: false,
        openLogin: false,
        openAccountVerified: false,
        openPurchaseSummary: false
      };

    case ModalActionTypes.HANDLE_MODAL_ACCOUNT_VERIFIED:
      return {
        ...state,
        openAccountVerified: payload,
        openCheckEmail: false,
        openRegister: false,
        openLogin: false,
        openPurchaseSummary: false
      };

    case ModalActionTypes.HANDLE_MODAL_PURCHASE_SUMMARY:
      return {
        ...state,
        openPurchaseSummary: payload,
        openAccountVerified: false,
        openCheckEmail: false,
        openRegister: false,
        openLogin: false
      };

    case ModalActionTypes.HANDLE_MODAL_PURCHASE_SUCCESS:
      return {
        ...state,
        openPurchaseSuccess: payload,
        openPurchaseSummary: false,
        openAccountVerified: false,
        openCheckEmail: false,
        openRegister: false,
        openLogin: false,
        openPurchaseError: false
      };

    case ModalActionTypes.HANDLE_MODAL_PURCHASE_ERROR:
      return {
        ...state,
        openPurchaseError: payload,
        openPurchaseSummary: false,
        openAccountVerified: false,
        openCheckEmail: false,
        openRegister: false,
        openLogin: false,
        openPurchaseSuccess: false
      };

    default:
      return state;
  }
};

export default modalReducer;
